import React from 'react';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router-dom';

import { InfoField, ChipBox } from '@occc/ui-design-system';
import { EarningMechanismTotalSpendOverTimeFragment } from '@occc/graphql';
import { displayAmount } from '@occc-app/lib/currency';

interface ITotalSpendOverTimeProps {
  earningMechanism: EarningMechanismTotalSpendOverTimeFragment;
}

export const TotalSpendOverTime: React.FC<ITotalSpendOverTimeProps> = ({ earningMechanism }) => {
  const navigate = useNavigate();
  const onChipClick = React.useCallback(
    (pgId: string) => {
      navigate(`/product-groups/${pgId}`);
    },
    [navigate],
  );

  return (
    <Grid container spacing={2}>
      <Grid item sm={6}>
        <InfoField
          disableTypography
          label='Excluded Product Groups'
          value={
            <ChipBox
              items={earningMechanism.ineligibleProductGroups}
              onClick={onChipClick}
              mt={0}
            />
          }
        />
      </Grid>
      <Grid item sm={3}>
        <InfoField
          label='Accumulation Threshold'
          value={displayAmount(earningMechanism.accumulationThreshold, false)}
        />
      </Grid>
    </Grid>
  );
};
